module.exports = __webpack_public_path__ + "Medical-gray-h.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/Medical-gray-h.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/Medical-gray-h.png
// module chunks = 10